import React from "react";
import { useContext } from "react";
import { StateContext } from "../../state";
import ConfigComponent from "../ConfigComponent";

export const Footer = () => {
  const [{configuration}] = useContext(StateContext);
  const {footer} = configuration;

  return (
    <footer id="footer">
      <div className="footerText">
        {footer.footerText && <div><ConfigComponent config={footer.footerText}/></div>}
        <div><span className="copyright">&copy; {new Date().getFullYear()}</span>{footer.copyrightPostText ? ` ${footer.copyrightPostText}` : ''}</div>
      </div>
      <div className="bottom-border"/>
    </footer>
  )
};

export default Footer;
